import { createSelector } from "@reduxjs/toolkit";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAdminRevenueThunk as onGetAdminRevenueThunk } from "../../../slices/users/thunk";
import { getFileUrl } from "../../../utils/GetAuthUser";
import { Header } from "../../../components/header/Header";

const Revenue = () => {
  const dispatch = useDispatch();
  const fileUrl = getFileUrl();

  // Selector
  const selectUserState = (state) => state.user;
  const userSelector = createSelector(selectUserState, (user) => ({
    isLoading: user.isLoading,
    userSubscribePlanRevenue: user.userSubscribePlanRevenue || [],
  }));

  const { isLoading, userSubscribePlanRevenue } = useSelector(userSelector);

  // Fetch API data
  useEffect(() => {
    dispatch(onGetAdminRevenueThunk());
  }, [dispatch]);

  return (
    <>
      <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color">
        <Header title="Revenue" showBack={true} />
      </header>

      <div className="w-full xl:max-[70%] flex flex-col border border-border_color rounded-[14px] p-5 mt-4">
        {/* Header */}
        <div className="flex items-center justify-between mb-3">
          <span className="text-lg sm:text-[22px] text-black font-bold font-grotesk">
            Revenue
          </span>

       
        </div>

        {/* Table */}
        <div className="overflow-x-auto  overflow-y-auto"  style={{  maxHeight: "calc(70vh - 100px)" }}>
          <table className="w-full min-w-[700px]">
            <thead>
              <tr className="border-b border-border_color">
                <th className="text-[16px] tracking-wider leading-10 text-black font-bold font-grotesk px-3 py-3 text-left">
                  Sr No.
                </th>
                <th className="text-[16px] tracking-wider leading-10 text-black font-bold font-grotesk px-3 py-3 text-left">
                  User
                </th>
                <th className="text-[16px] tracking-wider leading-10 text-black font-bold font-grotesk px-3 py-3 text-left">
                  Portal Fee
                </th>
                <th className="text-[16px] tracking-wider leading-10 text-black font-bold font-grotesk px-3 py-3 text-left">
                  Artist
                </th>
                <th className="text-[16px] tracking-wider leading-10 text-black font-bold font-grotesk px-3 py-3 text-left">
                  Artist Amount
                </th>
                <th className="text-[16px] tracking-wider leading-10 text-black font-bold font-grotesk px-3 py-3 text-left">
                  Transfer ID
                </th>
              </tr>
            </thead>

            <tbody>
              {isLoading ? (
                // Skeleton rows
                Array.from({ length: 6 }).map((_, index) => (
                  <tr key={`skeleton-${index}`} className={(index + 1) % 2 === 0 ? "bg-[#2878870F]" : "bg-transparent"}>
                    <td className="px-3 py-3">
                      <div className={`h-7 w-7 rounded-lg ${(index + 1) % 2 === 0 ? "bg-white" : "bg-[#2878870F]"} animate-pulse`} />
                    </td>
                    <td className="px-3 py-3">
                      <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-full bg-gray-200 animate-pulse" />
                        <div className="h-4 w-24 bg-gray-200 rounded animate-pulse" />
                      </div>
                    </td>
                    <td className="px-3 py-3">
                      <div className="h-4 w-16 bg-gray-200 rounded animate-pulse" />
                    </td>
                    <td className="px-3 py-3">
                      <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-full bg-gray-200 animate-pulse" />
                        <div className="h-4 w-24 bg-gray-200 rounded animate-pulse" />
                      </div>
                    </td>
                    <td className="px-3 py-3">
                      <div className="h-4 w-20 bg-gray-200 rounded animate-pulse" />
                    </td>
                    <td className="px-3 py-3">
                      <div className="h-4 w-28 bg-gray-200 rounded animate-pulse" />
                    </td>
                  </tr>
                ))
              ) : userSubscribePlanRevenue && userSubscribePlanRevenue.length > 0 ? (
                userSubscribePlanRevenue.map((plan, index) => (
                  <tr
                    key={plan.id || index}
                    className={(index + 1) % 2 === 0 ? "bg-[#2878870F]" : "bg-transparent"}
                  >
                    {/* Sr# */}
                    <td className="px-3 py-3  first:rounded-l-lg last:rounded-r-lg bg-transparent">
                      <div className={`h-7 w-7 rounded-lg  flex items-center justify-center text-sm tracking-wider font-medium font-grotesk text-black  ${(index + 1) % 2 === 0 ? "bg-white" : "bg-[#2878870F]"}`}>
                        {index + 1}
                      </div>
                    </td>

                    {/* User with image */}
                    <td className="px-3 py-3">
                      <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-full overflow-hidden bg-gray-200">
                          <img
                            src={
                              plan.userImage
                                ? `${fileUrl}/${plan.userImage}`
                                : "/default-avatar.png"
                            }
                            alt="User"
                            className="w-full h-full object-cover"
                            onError={(e) =>
                              (e.target.src = "/default-avatar.png")
                            }
                          />
                        </div>
                        <span className="text-sm tracking-wider font-medium font-grotesk text-black">
                          {plan.userName || "Unknown"}
                        </span>
                      </div>
                    </td>

                    {/* User Type */}
                    <td className="px-3 py-3 text-sm tracking-wider font-medium font-grotesk text-black">
                      ${plan.portalFee || "N/A"}
                    </td>

                    {/* Plan Name */}
                    <td className="px-3 py-3">
                      <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-full overflow-hidden bg-gray-200">
                          <img
                            src={
                              plan.artistImage
                                ? `${fileUrl}/${plan.artistImage}`
                                : "/default-avatar.png"
                            }
                            alt="User"
                            className="w-full h-full object-cover"
                            onError={(e) =>
                              (e.target.src = "/default-avatar.png")
                            }
                          />
                        </div>
                        <span className="text-sm tracking-wider font-medium font-grotesk text-black">
                          {plan.artistName || "Unknown"}
                        </span>
                      </div>
                    </td>

                    {/* Plan Amount */}
                    <td className="px-3 py-3 text-sm tracking-wider font-medium font-grotesk text-black">
                      ${plan.artistAmount || "0.00"}
                    </td>
                    <td className="px-3 py-3 text-sm tracking-wider font-medium font-grotesk text-black  first:rounded-l-lg last:rounded-r-lg bg-transparent">
                      {plan.transferId || "0.00"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="  py-6 text-center text-xl tracking-wider font-bold font-grotesk text-gray-500">
                    No Revenue Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Revenue;
